import { createContext, useContext, useState, ReactNode } from "react";
import { resolveInitialMode, type ThemeMode } from "../theme/appTheme";

// Kept as the tool's own key so preferences stored before the suite-wide
// alignment keep working; the resolution logic itself is shared.
const THEME_STORAGE_KEY = "themeMode";

interface ThemeContextType {
  mode: ThemeMode;
  toggleMode: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [mode, setMode] = useState<ThemeMode>(() =>
    resolveInitialMode(THEME_STORAGE_KEY)
  );

  const toggleMode = () => {
    setMode((prev) => {
      const next = prev === "light" ? "dark" : "light";
      localStorage.setItem(THEME_STORAGE_KEY, next);
      return next;
    });
  };

  return (
    <ThemeContext.Provider value={{ mode, toggleMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeMode = () => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error("useThemeMode must be used within ThemeProvider");
  return context;
};
